var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessCircle = function SvgSuccessCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "green",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.667c3.666 0 6.666-3 6.666-6.667s-3-6.667-6.666-6.667-6.667 3-6.667 6.667 3 6.667 6.667 6.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.167 8 1.887 1.887 3.78-3.774"
  }))));
};
export default SvgSuccessCircle;